<template>
  <div class="modal-container">
    <div class="add-box clearfix">
      <table-header
        @add="insertEvent"
        @remove="removeEvent"
        @copy="paste"
      ></table-header>
      <vxe-table
        border
        show-overflow
        ref="xTable"
        class="table-style"
        max-height="420"
        :auto-resize="true"
        :data="tableData"
        :edit-rules="showImport ? importformRules : formRules"
        :edit-config="{ trigger: 'click', mode: 'cell' }"
        :show-footer="true"
        @checkbox-all="selectAllEvent"
        @checkbox-change="selectChangeEvent"
        :footer-method="footerMethod"
        :footer-cell-class-name="footerCellClassName"
      >
        <!-- <vxe-table-column width="40" align="center">
          <template v-slot:header>
            <Button class="add-btn" icon="md-add" @click="insertEvent()"></Button>
          </template>
          <template v-slot="{ row,$rowIndex }">
            <Button class="del-btn" icon="md-remove" @click="removeEvent(row,$rowIndex)"></Button>
          </template>
        </vxe-table-column>-->
        <vxe-table-column
          type="checkbox"
          align="center"
          width="50"
        ></vxe-table-column>
        <vxe-table-column field="no" title="序号" width="110" v-if="showImport">
          <template v-slot="scope">
            <vxe-input
              v-model="scope.row.no"
              placeholder="请输入序号"
            ></vxe-input>
          </template>
        </vxe-table-column>
        <vxe-table-column
          field="buyerOrdersNum"
          title="订单编号"
          width="150"
          v-if="orderTypeAll == 1"
          show-overflow
        >
          <template v-slot="{ row, $rowIndex }">
            <a
              v-if="!isDisabled"
              class="sel-link"
              @click="
                openLink({
                  i: $rowIndex,
                  data: tableData,
                  key: 'buyerOrdersNum',
                })
              "
              target="_black"
              >{{
                row.buyerOrdersNum === null || row.buyerOrdersNum === ""
                  ? "选择关联订单"
                  : row.buyerOrdersNum
              }}</a
            >
            <span v-if="isDisabled">{{ row.buyerOrdersNum }}</span>
          </template>
        </vxe-table-column>
        <vxe-table-column
          field="buyerOrdersNum"
          title="订单编号"
          width="150"
          v-if="orderTypeAll == 4"
          show-overflow
        >
          <template v-slot="{ row, $rowIndex }">
            <a
              class="sel-link"
              @click="
                openLink2({
                  i: $rowIndex,
                  data: tableData,
                  key: 'allOrdersNum',
                })
              "
              target="_black"
              >{{
                row.allOrdersNum === null || row.allOrdersNum === ""
                  ? "选择关联订单"
                  : row.allOrdersNum
              }}</a
            >
          </template>
        </vxe-table-column>
        <vxe-table-column
          field="sellerOrderNum"
          title="订单编号"
          width="150"
          v-if="orderTypeAll == 2 || orderTypeAll == 3"
        >
          <template v-slot="{ row, $rowIndex }">
            <a
              v-if="!isDisabled"
              class="sel-link"
              @click="
                openLink({
                  i: $rowIndex,
                  data: tableData,
                  key: 'sellerOrderNum',
                })
              "
              target="_black"
              >{{
                row.sellerOrderNum === null || row.sellerOrderNum === ""
                  ? "选择关联订单"
                  : row.sellerOrderNum
              }}</a
            >
            <span v-if="isDisabled">{{ row.sellerOrderNum }}</span>
          </template>
        </vxe-table-column>
        <vxe-table-column field="logistics" title="物流编号" min-width="137">
          <template v-slot="{ row, $rowIndex }">
            <a
              class="sel-link"
              @click="
                openLogisticsLink({
                  i: $rowIndex,
                  data: tableData,
                  key: 'logistics',
                })
              "
              target="_black"
              >{{
                row.logistics === null || row.logistics === ""
                  ? "选择物流订单"
                  : row.logistics
              }}</a
            >
          </template>
        </vxe-table-column>
        <vxe-table-column title="所属公司" width="150" field="compName">
          <template v-slot="{ row }">
            <platform-corp
              :row="row"
              :field="'compName'"
              @select="selectCompany"
              :placeholder="'请选择平台企业'"
              v-if="
                row.buyerOrdersNum == null &&
                row.sellerOrderNum == null &&
                row.allOrdersNum == null
              "
              @blur="clearTableV"
            ></platform-corp>
            <span v-else>{{ row.compName }}</span>
          </template>
        </vxe-table-column>
        <vxe-table-column
          title="结算信息性质"
          width="140"
          field="isIncludedTax"
        >
          <template v-slot="{ row }">
            <vxe-select
              v-model="row.isIncludedTax"
              placeholder="请选择"
              @blur="clearTableV"
              :options="taxType"
              transfer
              d
            >
              <vxe-option value="1" label="托运人货物交接确认"></vxe-option>
              <vxe-option value="2" label="承运人货物交接确认"></vxe-option>
              <vxe-option value="3" label="实际承运人货物交接确认"></vxe-option>
            </vxe-select>
          </template>
        </vxe-table-column>
        <vxe-table-column field="addTime" title="结算时间" width="116">
          <template v-slot="{ row }">
            <vxe-input
              v-model="row.addTime"
              placeholder="选择日期"
              type="date"
              transfer
              @blur="clearTableV"
            ></vxe-input>
          </template>
        </vxe-table-column>
        <vxe-table-column field="goodsName" title="货名" width="110">
          <template v-slot="scope">
            <vxe-input
              v-model="scope.row.goodsName"
              placeholder="必填"
              @blur="clearTableV"
            ></vxe-input>
          </template>
        </vxe-table-column>
        <vxe-table-column field="goodsRule" title="规格" width="110">
          <template v-slot="{ row }">
            <vxe-input v-model="row.goodsRule" placeholder="选填"></vxe-input>
          </template>
        </vxe-table-column>
        <vxe-table-column field="goodsUnit" title="单位" width="70">
          <template v-slot="scope">
            <!-- <vxe-input
              v-model="scope.row.goodsUnit"
              placeholder="必填"
              @blur="clearTableV"
            ></vxe-input> -->
            <vxe-select
              v-model="scope.row.goodsUnit"
              placeholder="请选择"
              :options="unitTypeOptions"
              @change="clearTableV"
              transfer
            ></vxe-select>
          </template>
        </vxe-table-column>
        <vxe-table-column field="counts" title="实际数量" width="116">
          <template v-slot="{ row, $rowIndex }">
            <vxe-input
              v-model="row.counts"
              placeholder="必填"
              v-on:input="inputcounts(row, $rowIndex)"
              @blur="clearTableV"
            ></vxe-input>
          </template>
        </vxe-table-column>
        <vxe-table-column field="price" title="单价" width="116">
          <template v-slot="{ row, $rowIndex }">
            <vxe-input
              v-model="row.price"
              placeholder="选填"
              v-on:input="inputcounts(row, $rowIndex)"
              @blur="clearTableV"
            ></vxe-input>
          </template>
        </vxe-table-column>
        <vxe-table-column field="receAmount" title="总金额" width="116">
          <template v-slot="{ row }">
            <vxe-input
              v-model="row.receAmount"
              placeholder="必填"
              @blur="clearTableV"
              v-on:input="updateFooterEvent()"
            ></vxe-input>
          </template>
        </vxe-table-column>
        <vxe-table-column field="note" title="摘要" width="116">
          <template v-slot="{ row }">
            <vxe-input v-model="row.note" placeholder="选填"></vxe-input>
          </template>
        </vxe-table-column>
        <vxe-table-column field="fileList" title="上传附件" width="180">
          <template v-slot="{ row }">
            <upload-list
              :row="row"
              :initFileList="row.fileList"
              :view="'packup'"
            ></upload-list>
          </template>
        </vxe-table-column>
      </vxe-table>
    </div>
    <div class="modal-footer add-btn-box">
      <Button status="primary" @click="impotEvent" v-if="showImport"
        >上传导入文件</Button
      >
      <Button status="primary" @click="commit">提 交</Button>
    </div>
    <vxe-modal
      v-model="orderVisible"
      title="选择订单"
      width="1300"
      height="560"
      resize
      remember
      position="center"
    >
      <choose-order-two
        ref="chooseOrderTwo"
        @chooseOrder="chooseOrderTwo"
        @blur="clearTableV"
        v-bind:orderType="orderTypeAll"
        :chainId="chainId"
      ></choose-order-two>
    </vxe-modal>
    <vxe-modal
      position="center"
      v-model="receivingOrderVisible"
      title="选择订单"
      width="1300"
      height="560"
      resize
      remember
    >
      <choose-receiving-order
        ref="chooseReceivingOrder"
        :orderId="orderId"
        @chooseOrder="chooseReceivingOrder"
      ></choose-receiving-order>
    </vxe-modal>
    <vxe-modal
      position="center"
      v-model="logisticsVisible"
      title="选择物流订单"
      width="1300"
      height="630"
      @close="closeLogistics"
      resize
    >
      <choose-logistics
        ref="chooseLogistics"
        @choose="chooseLogistics"
        @close="closeLogistics"
        v-bind:orderTypeTwo="orderTypeTwo"
        v-bind:orderNum="orderNum"
      ></choose-logistics>
    </vxe-modal>
    <!-- <vxe-modal v-model="fileVisible" title="附件上传" width="600" height="600" resize remember>
      <upload-img ref="uploadImg" @fileList="getFileList" :viewType="true"></upload-img>
    </vxe-modal>-->
    <vxe-modal
      v-model="messageVisible"
      title="消息提示"
      width="600"
      position="center"
      height="350"
      @close="closeMessage"
      remember
    >
      <Message ref="messageModal" @close="closeMessage"></Message>
    </vxe-modal>
  </div>
</template>

<script>
import ChooseLogistics from "@/components/modal/ChooseLogistics";
import XLSX from "xlsx";
import TableHeader from "../../components/common/TableHeader";
import UploadList from "@/components/common/UploadList";
import PlatformCorp from "@/components/common/PlatformCorp";

import XEUtils from "xe-utils/methods/xe-utils";
import Message from "@/components/common/Message";
import ChooseReceivingOrder from "@/components/modal/ChooseReceivingOrder";
import ChooseOrderTwo from "@/components/modal/ChooseOrderTwo";
import { getExcelTime } from "@/utils/util";
import $api from "@/apiProvider";
import { showLoading, hideLoading } from "@/utils/util";
import moment from "moment";

export default {
  components: {
    ChooseLogistics,
    ChooseOrderTwo,
    ChooseReceivingOrder,
    Message,
    TableHeader,
    UploadList,
    PlatformCorp,
  },
  props: {
    orderType: {
      default: null,
    },
    showImport: {
      default: false,
    },
    isIncludedTax: {
      type: [String, Number],
      default: null,
    },
    orderId: {
      default: null,
    },
  },
  data() {
    return {
      compMap: new Map(),
      uploadList: [],
      records: [],
      chainId: null,
      orderNum: null,
      compNameAll: null,
      tableColumn: {},
      fileVisible: false,
      info: null, // 存储点击事件
      logisticsInfo: null, // 存储点击事件
      addFileInfo: null, // 存储点击事件
      taxType: null,
      isClear: false,
      isDisabled: false,
      logisticsVisible: false,
      isChooseOrder: false,
      receivingOrderVisible: false,
      aboutOrder: {},
      orderTypeTwo: null,
      orderTypeAll: null,
      orderNumList: [],
      formRules: {
        goodsName: [{ required: true, message: "请输入货名" }],
        counts: [{ required: true, message: "请输入实际数量" }],
        goodsUnit: [{ required: true, message: "请输入单位" }],
        addTime: [{ required: true, message: "请选择结算时间" }],
        compName: [{ required: true, message: "请选择公司" }],
        receAmount: [{ required: true, message: "请输入总金额" }],
        // price: [{ required: true, message: "请输入单价" }],
        // isIncludedTax: [{ required: true, message: "请选择结算性质" }],
      },
      importformRules: {
        buyerOrdersNum: [{ required: true, message: "请输入订单号" }],
        sellerOrderNum: [{ required: true, message: "请输入订单号" }],
        goodsName: [{ required: true, message: "请输入货名" }],
        counts: [{ required: true, message: "请输入实际数量" }],
        goodsUnit: [{ required: true, message: "请输入单位" }],
        addTime: [{ required: true, message: "请选择结算时间" }],
        compName: [{ required: true, message: "请选择公司" }],
        receAmount: [{ required: true, message: "请输入总金额" }],
        // price: [{ required: true, message: "请输入单价" }],
        // isIncludedTax: [{ required: true, message: "请选择结算性质" }],
      },
      tableData: [
        {
          no: 1,
          addTime: null,
          receAmount: null,
          counts: null,
          compName: null,
          platformCompanyId: null,
          isIncludedTax: this.isIncludedTax,
          goodsName: null,
          logisticsIdList: [],
          logistics: null,
          logisticsNumList: [],
          fileList: [],
          fileUuidList: [],
          buyerOrdersNum: null,
          sellerOrderNum: null,
          allOrdersNum: null,
          note: null,
          ordersBuyerId: null,
          ordersSellerId: null,
          ordersSellerLv2Id: null,
          price: null,
          goodsRule: null,
          goodsUnit: null,
        },
      ],
      tableDataCopy: [],
      orderVisible: false,
      visible: false,
      messageVisible: false,
      unitTypeOptions: [],
    };
  },
  created() {
    this.orderTypeTwo = this.orderType;
    this.orderTypeAll = this.orderType;
    this.getDicDate();
  },
  methods: {
    getDicDate() {
      this.unitTypeOptions = [];

      $api.other.getUnitTypeModel
        .GET({
          params: {
            page: 1,
            rows: 100,
          },
        })
        .then((res) => {
          res.data.forEach((item) => {
            var obj = {
              label: item.dictText,
              value: item.dictText,
            };
            this.unitTypeOptions.push(obj);
          });
        });
    },
    selectChangeEvent({ checked, row }) {
      if (checked) {
        this.records.push(row);
      } else {
        this.records.splice(row, 1);
      }
    },
    selectAllEvent({ checked, records }) {
      if (checked) {
        this.records = records;
      } else {
        this.records = [];
      }
    },
    paste() {
      let records = this.records.sort((a, b) => a.no - b.no);
      if (records.length > 0) {
        records.map((i) => {
          let record = Object.assign({}, i);
          record.no = this.$refs.xTable.data.length + 1;
          this.pushIntoTable(record);
        });
      } else {
        this.$XModal.message({
          status: "error",
          message: "请选择需要复制的结算信息！",
        });
      }
    },
    pushIntoTable(record) {
      let { row: newRow } = this.$refs.xTable.insertAt(record, -1);
      this.$refs.xTable.data.push(record);
      // this.$refs.xTable.setActiveCell(newRow, "ordersSellerId");
    },
    copyTableDataTemp() {},

    async insertEvent(row) {
      var isIncludedTax = null;
      if (this.orderTypeAll == 1) {
        isIncludedTax = "托运人货物交接确认";
      }
      if (this.orderTypeAll == 2) {
        isIncludedTax = "承运人货物交接确认";
      }
      if (this.orderTypeAll == 3) {
        isIncludedTax = "实际承运人货物交接确认";
      }
      console.log(this.$refs.xTable.getTableData().fullData);

      let record = {
        no: this.$refs.xTable.data.length + 1,
        addTime: null,
        receAmount: null,
        counts: null,
        compName: null,
        platformCompanyId: null,
        goodsName: null,
        logisticsIdList: [],
        buyerOrdersNum: null,
        sellerOrderNum: null,
        isIncludedTax: isIncludedTax,
        logisticsNumList: [],
        logistics: null,
        allOrdersNum: null,
        fileList: [],
        fileUuidList: [],
        note: null,
        ordersBuyerId: null,
        ordersSellerId: null,
        ordersSellerLv2Id: null,
        price: null,
        goodsRule: null,
        goodsUnit: null,
      };
      if (this.isDisabled) {
        if (this.orderTypeAll == 1) {
          record.buyerOrdersNum = this.orderNum;
          record.ordersBuyerId = this.orderId;
          record.compName = this.compNameAll;
        } else if (this.orderTypeAll == 2) {
          record.ordersSellerId = this.orderId;
          record.sellerOrderNum = this.orderNum;
          record.compName = this.compNameAll;
        } else if (this.orderTypeAll == 3) {
          record.ordersSellerLv2Id = this.orderId;
          record.sellerOrderNum = this.orderNum;
          record.compName = this.compNameAll;
        }
        console.log(this.aboutOrder);
        if (this.aboutOrder && this.aboutOrder.goodsName) {
          record.goodsName = this.aboutOrder.goodsName;
        }
        if (this.aboutOrder && this.aboutOrder.rule) {
          record.goodsRule = this.aboutOrder.rule;
        }
        if (this.aboutOrder && this.aboutOrder.unit) {
          record.goodsUnit = this.aboutOrder.unit;
        }
        if (this.aboutOrder && this.aboutOrder.price) {
          record.price = this.aboutOrder.price;
        }
      }
      this.pushIntoTable(record);
      // await this.$refs.xTable.setActiveCell(newRow, "ordersBuyerId");
    },
    openLink(obj) {
      this.info = obj;
      if (this.isDisabled == false) {
        this.orderVisible = true;
        this.$refs.chooseOrderTwo.init();
      }
    },
    openLink2(obj) {
      this.info = obj;
      if (this.isDisabled == false && this.orderTypeAll == 4) {
        this.receivingOrderVisible = true;
        this.$refs.chooseReceivingOrder.init();
      } else {
        this.orderVisible = true;
        this.$refs.chooseOrderTwo.init();
      }
    },
    openLogisticsLink(obj) {
      this.logisticsInfo = obj;
      let data = this.logisticsInfo.data;
      let i = this.logisticsInfo.i;
      var isChooseOrder = false;
      if (this.orderTypeAll == 1) {
        if (
          data[i]["ordersBuyerId"] == null ||
          data[i]["ordersBuyerId"] == ""
        ) {
          isChooseOrder = true;
        }
      }
      if (this.orderTypeAll == 2) {
        if (
          data[i]["ordersSellerId"] == null ||
          data[i]["ordersSellerId"] == ""
        ) {
          isChooseOrder = true;
        }
      }
      if (this.orderTypeAll == 3) {
        if (
          data[i]["ordersSellerLv2Id"] == null ||
          data[i]["ordersSellerLv2Id"] == ""
        ) {
          isChooseOrder = true;
        }
      }
      if (this.orderTypeAll == 4) {
        if (
          data[i]["ordersSellerLv2Id"] == null ||
          data[i]["ordersSellerLv2Id"] == "" ||
          data[i]["ordersBuyerId"] == null ||
          data[i]["ordersBuyerId"] == "" ||
          data[i]["ordersSellerId"] == null ||
          data[i]["ordersSellerId"] == ""
        ) {
          isChooseOrder = true;
        }
      }
      if (isChooseOrder) {
        this.$XModal.alert({
          message: "请先选择订单",
          status: "error",
        });
        return;
      }

      this.$refs.chooseLogistics.init();
      this.logisticsVisible = true;
    },
    closeMessage() {
      this.messageVisible = false;
    },
    inputcounts(row, rowIndex) {
      if (row.counts) {
        if (row.price) {
          this.tableData[rowIndex].receAmount =
            Math.round(row.counts * row.price * 100) / 100;
        }
      }
      this.updateFooterEvent();
    },

    async commit() {
      var self = this;
      let data = this.$refs.xTable.getTableData().fullData;
      console.log(data);
      console.log("xxxxx" + this.orderTypeAll);
      var tempCopy = [];
      var buyerTemp = [];
      var sellerTemp = [];
      var secTemp = [];

      let sts = await this.validEvent();
      if (!sts) {
        this.$XModal.message({ status: "error", message: "校验不通过！" });
        return;
      }
      showLoading();
      self.tableData.forEach(function (item, index) {
        let obj = {};
        obj.fileUuidList = [];
        obj.addTime = self.$utils.timestamp(item.addTime);
        obj.compName = item.compName;
        obj.receAmount = item.receAmount;
        obj.counts = item.counts;
        obj.goodsName = item.goodsName;
        obj.note = item.note;
        obj.platformCompanyId = item.compNameId;
        obj.ordersBuyerId = null;
        obj.ordersSellerId = null;
        obj.ordersSellerLv2Id = null;
        if (self.orderTypeAll == 1) {
          obj.ordersBuyerNum = item.buyerOrdersNum;
          obj.ordersBuyerId = item.ordersBuyerId;
        }
        if (self.orderTypeAll == 2) {
          obj.ordersSellerNum = item.sellerOrderNum;
          obj.ordersSellerId = item.ordersSellerId;
        }
        if (self.orderTypeAll == 3) {
          obj.ordersSellerLv2Num = item.sellerOrderNum;
          obj.ordersSellerLv2Id = item.ordersSellerLv2Id;
        }

        obj.price = item.price;
        obj.goodsRule = item.goodsRule;
        obj.goodsUnit = item.goodsUnit;
        obj.logisticsIdList = item.logisticsIdList;
        obj.logisticsNumList = item.logisticsNumList;
        obj.fileUuidList = item.fileUuidList;

        // if (item.fileList) {
        //   item.fileList.map((j) => {
        //     obj.fileUuidList.push(j.uuid);
        //   });
        // }
        if (self.showImport) {
          obj.no = item.no;
        }
        tempCopy.push(obj);
        console.log(tempCopy);
      });
      var url = "createBuyerReceiveGoods";
      if (self.orderTypeAll == 1) {
        url = "createBuyerReceiveGoods";
      }
      if (self.orderTypeAll == 2) {
        url = "createSellerReceiveGoods";
      }
      if (self.orderTypeAll == 3) {
        url = "createSellerLv2ReceiveGoods";
      }
      let res = await $api.receiving.request(url, tempCopy);
      hideLoading();
      if (res.status == 1) {
        var isIncludedTax = null;
        if (this.orderTypeAll == 1) {
          isIncludedTax = "托运人货物交接确认";
        }
        if (this.orderTypeAll == 2) {
          isIncludedTax = "承运人货物交接确认";
        }
        if (this.orderTypeAll == 3) {
          isIncludedTax = "实际承运人货物交接确认";
        }
        this.$Message["success"]({
          background: true,
          content: "创建成功",
        });
        (this.tableData = [
          {
            addTime: null,
            receAmount: null,
            counts: null,
            isIncludedTax: isIncludedTax,
            platformCompanyId: null,
            compName: null,
            goodsName: null,
            logisticsIdList: [],
            logisticsNumList: [],
            logistics: null,
            note: null,
            fileList: [],
            fileUuidList: [],
            ordersBuyerId: null,
            ordersSellerId: null,
            ordersSellerLv2Id: null,
            price: null,
            buyerOrdersNum: null,
            sellerOrderNum: null,
            goodsRule: null,
            goodsUnit: null,
          },
        ]),
          this.$emit("createCommit", false);
      } else {
        let data = res.data;
        let message = "";
        let message2 = "";
        var messageMap = new Map();
        if (data.length > 0) {
          let failArrayList = [];
          data.map((i) => {
            failArrayList.push(i.failArrayIndex);
            messageMap.set(i.failArrayIndex, i.failMsg);
            message =
              message +
              "第" +
              (i.failArrayIndex + 1) +
              "行，" +
              i.failMsg +
              "\n";
          });
          if (failArrayList.length > 0) {
            let newTableData = [];
            self.tableData.forEach((item, index) => {
              if (failArrayList.includes(index)) {
                newTableData.push(item);
                message2 =
                  message2 +
                  "序号" +
                  item.no +
                  "，" +
                  messageMap.get(index) +
                  "\n";
              }
            });
            self.tableData = newTableData;
          }
        }
        if (message === "") {
          this.$XModal.alert({
            message: "接口异常",
            status: "error",
          });
        } else {
          if (self.showImport) {
            message = message2;
          }
          this.$refs.messageModal.setMessage(message);
          this.messageVisible = true;
        }
      }
    },
    clearTableV() {
      this.$refs.xTable.clearValidate();
    },
    reCommit() {
      this.tableData = [
        {
          addTime: null,
          receAmount: null,
          counts: null,
          isIncludedTax: this.isIncludedTax,
          platformCompanyId: null,
          compName: null,
          goodsName: null,
          logisticsIdList: [],
          logisticsNumList: [],
          logistics: null,
          fileList: [],
          fileUuidList: [],
          buyerOrdersNum: null,
          sellerOrderNum: null,
          allOrdersNum: null,
          note: null,
          ordersBuyerId: null,
          ordersSellerId: null,
          ordersSellerLv2Id: null,
          price: null,
          goodsRule: null,
          goodsUnit: null,
        },
      ];
    },
    addFile(obj) {
      this.addFileInfo = obj;
      let data = this.addFileInfo.data;
      let i = this.addFileInfo.i;
      this.uploadList = data[i]["fileAddUrlList"];
      console.log("xxxx");
      this.$refs.uploadImg.setList(this.uploadList);
      this.fileVisible = true;
    },
    getFileList(row) {
      console.log(row);
      let data = this.addFileInfo.data;
      let i = this.addFileInfo.i;
      data[i]["fileAddUrlList"] = row;
      // (data[i]["fileAddNameList"] = row.addUrlList.name),
      // data[i]["fileAddUrlList"] = row.addUrlList.url;
    },
    // removeEvent(row, i) {
    //   this.$refs.xTable.remove(row);
    //   this.$refs.xTable.data.splice(i, 1);
    // },
    removeEvent() {
      let records = this.records;
      if (records.length > 0) {
        if (this.$refs.xTable.tableData.length > 1) {
          this.$XModal.confirm("您确定要删除选中数据?").then((type) => {
            if (type === "confirm") {
              let records = this.records;
              records.map((i) => {
                this.$refs.xTable.remove(i);
                let key = this.$refs.xTable.data.indexOf(i);
                this.$refs.xTable.data.splice(key, 1);
              });
              this.records = [];
              if (this.showImport === false) {
                this.$refs.xTable.data.map((j, index) => {
                  j.no = index + 1;
                });
              }
            }
          });
        } else {
          this.$XModal.alert({
            message: "已经是最后一条了！",
            status: "warning",
          });
        }
      } else {
        this.$XModal.message({
          status: "error",
          message: "请选择需要删除的结算信息！",
        });
      }
    },
    chooseOrderTwo(row) {
      this.clearTableV();
      let data = this.info.data;
      let i = this.info.i;
      let key = this.info.key;
      // this.isChooseOrder = true;
      if (this.orderNum != row.buyerOrdersNum) {
        data[i]["logisticsIdList"] = [];
        data[i]["counts"] = null;
        data[i]["logistics"] = null;
        data[i]["receAmount"] = null;
      }
      if (this.orderTypeAll == 1) {
        data[i][key] = row.buyerOrdersNum;
        this.orderNum = row.buyerOrdersNum;
        data[i]["ordersBuyerId"] = row.id;
        data[i]["compName"] = row.platformCompany;
        data[i]["platformCompanyId"] = row.platformCompanyId;
      }
      if (this.orderTypeAll == 2) {
        data[i][key] = row.sellerOrdersNum;
        this.orderNum = row.sellerOrdersNum;
        data[i]["ordersSellerId"] = row.id;
        data[i]["compName"] = row.platformCompany;
        data[i]["platformCompanyId"] = row.platformCompanyId;
      }
      if (this.orderTypeAll == 3) {
        data[i][key] = row.sellerOrdersNum;
        this.orderNum = row.sellerOrdersNum;
        data[i]["ordersSellerLv2Id"] = row.id;
        data[i]["compName"] = row.platformCompany;
        data[i]["platformCompanyId"] = row.platformCompanyId;
      }
      if (row.goodsRtnVos[0]) {
        data[i]["goodsName"] = row.goodsRtnVos[0].goodsName;
        data[i]["goodsRule"] = row.goodsRtnVos[0].rule;
        data[i]["goodsUnit"] = row.goodsRtnVos[0].unit;
        data[i]["price"] = row.goodsRtnVos[0].price;
      }

      // data[i]["counts"] = row.goodsRtnVos[0].counts;
      // if (data[i]["counts"] && data[i]["price"]) {
      //    data[i]["receAmount"] = Math.round(data[i]["counts"] * data[i]["price"] * 100) / 100;
      // }
      this.orderVisible = false;
    },
    selectCompany() {
      this.clearTableV();
    },
    chooseReceivingOrder(row, type, orderId) {
      this.clearTableV();
      this.orderTypeAll = type;
      this.orderTypeTwo = type;
      this.chainId = orderId;
      console.log(row);
      let data = this.info.data;
      let i = this.info.i;
      let key = this.info.key;

      data[i]["compName"] = row.platformCompany;
      // this.isChooseOrder = true;
      if (this.orderNum != row.buyerOrdersNum) {
        data[i]["logisticsIdList"] = [];
        data[i]["counts"] = null;
        data[i]["logistics"] = null;
        data[i]["receAmount"] = null;
      }
      if (type == 1) {
        data[i][key] = row.buyerOrdersNum;
        this.orderNum = row.buyerOrdersNum;
        data[i]["buyerOrdersNum"] = row.buyerOrdersNum;
        data[i]["isIncludedTax"] = "托运人货物交接确认";
        data[i]["ordersBuyerId"] = row.id;
      }
      if (type == 2) {
        data[i][key] = row.sellerOrdersNum;
        this.orderNum = row.sellerOrdersNum;
        data[i]["ordersSellerId"] = row.id;
        data[i]["isIncludedTax"] = "承运人货物交接确认";
        data[i]["sellerOrderNum"] = row.sellerOrdersNum;
      }
      if (type == 3) {
        data[i][key] = row.sellerOrdersNum;
        this.orderNum = row.sellerOrdersNum;
        data[i]["ordersSellerLv2Id"] = row.id;
        data[i]["isIncludedTax"] = "实际承运人货物交接确认";
        data[i]["sellerOrderNum"] = row.sellerOrdersNum;
      }
      if (row.goodsRtnVos[0]) {
        data[i]["goodsName"] = row.goodsRtnVos[0].goodsName;
        data[i]["goodsRule"] = row.goodsRtnVos[0].rule;
        data[i]["goodsUnit"] = row.goodsRtnVos[0].unit;

        data[i]["price"] = row.goodsRtnVos[0].price;
      }
      this.receivingOrderVisible = false;
    },

    setRelationOrder(aboutOrder, orderTypeAll) {
      this.aboutOrder = aboutOrder;
      this.isDisabled = true;
      this.orderTypeAll = orderTypeAll;
      this.compNameAll = aboutOrder.platformCompany;
      this.tableData[0]["compName"] = aboutOrder.platformCompany;
      if (orderTypeAll == 1) {
        this.tableData[0]["buyerOrdersNum"] = aboutOrder.orderNum;
        this.orderNum = aboutOrder.orderNum;
        this.orderId = aboutOrder.orderId;
        this.tableData[0]["ordersBuyerId"] = aboutOrder.orderId;
      }
      if (orderTypeAll == 2) {
        this.tableData[0]["sellerOrderNum"] = aboutOrder.orderNum;
        this.orderNum = aboutOrder.orderNum;
        this.orderId = aboutOrder.orderId;
        this.tableData[0]["ordersSellerId"] = aboutOrder.orderId;
      }
      if (orderTypeAll == 3) {
        this.tableData[0]["sellerOrderNum"] = aboutOrder.orderNum;
        this.orderNum = aboutOrder.orderNum;
        this.orderId = aboutOrder.orderId;
        this.tableData[0]["ordersSellerLv2Id"] = aboutOrder.orderId;
      }
      this.tableData[0]["goodsName"] = aboutOrder.goodsName;
      this.tableData[0]["goodsRule"] = aboutOrder.rule;
      this.tableData[0]["goodsUnit"] = aboutOrder.unit;
      this.tableData[0]["price"] = aboutOrder.price;
      this.isChooseOrder = true;
    },
    async validEvent() {
      let errMap = await this.$refs.xTable.validate().catch((errMap) => errMap);
      return errMap ? false : true;
    },
    chooseLogistics(row) {
      let data = this.logisticsInfo.data;
      // console.log(data);
      let i = this.logisticsInfo.i;
      let key = this.logisticsInfo.key;
      var logisticsIds = [];
      var addcounts = 0;
      row.forEach(function (item, index) {
        logisticsIds.push(item.id);
        addcounts = addcounts + item.realCount;
      });
      var logisticsNums = [];
      row.forEach(function (item, index) {
        logisticsNums.push(item.logisticsNum);
      });
      data[i][key] = logisticsNums.join(",");
      data[i]["logisticsIdList"] = logisticsIds;
      data[i]["counts"] = Math.round(addcounts * 100) / 100;
      if (addcounts && data[i]["price"]) {
        data[i]["receAmount"] =
          Math.round(addcounts * data[i]["price"] * 100) / 100;
      }
      console.log(data);
      this.updateFooterEvent();
      this.logisticsVisible = false;
    },
    closeLogistics() {
      this.logisticsVisible = false;
      this.updateFooterEvent();
      this.$refs.chooseLogistics.close();
    },
    impotEvent() {
      this.$refs.xTable
        .readFile({
          types: ["xls", "xlsx"],
        })
        .then((evnt) => {
          this.$Spin.show({
            render: (h) => {
              return h("div", [
                h("Icon", {
                  class: "demo-spin-icon-load",
                  props: {
                    type: "ios-loading",
                    size: 18,
                  },
                }),
                h("div", "导入中..."),
              ]);
            },
          });
          const files = evnt.target.files;
          const fileReader = new FileReader();
          fileReader.onload = (ev) => {
            const data = ev.target.result;
            const workbook = XLSX.read(data, { type: "binary" });
            const csvData = XLSX.utils.sheet_to_csv(
              Object.values(workbook.Sheets)[0]
            );
            const tableData = [];
            // 解析数据
            csvData.split("\n").forEach((vRow, index) => {
              if (vRow && index > 0) {
                const vCols = vRow.split(",");
                this.orderNumList.push(vCols[1]);
              }
            });
            let promiseRes;
            if (this.orderTypeAll == 1) {
              promiseRes = this.queryOrdersBuyerSalesInfoList(
                this.orderNumList
              );
            } else if (this.orderTypeAll == 2) {
              promiseRes = this.queryOrdersSellerSalesInfoList(
                this.orderNumList
              );
            } else if (this.orderTypeAll == 3) {
              promiseRes = this.queryOrdersSellerLv2SalesInfoList(
                this.orderNumList
              );
            }
            promiseRes.then(() => {
              csvData.split("\n").forEach((vRow, index) => {
                if (vRow && index > 0) {
                  const vCols = vRow.split(",");
                  const item = {
                    no: vCols[0],
                    // buyerOrdersNum: vCols[1],
                    // sellerOrderNum: vCols[1],
                    logistics: vCols[2],
                    // compName: vCols[2],
                    // logisticsNumList:vCols[2],
                    // isIncludedTax: vCols[3],
                    addTime: moment(vCols[3]).format("YYYY-MM-DD"),
                    goodsName: vCols[4],
                    goodsRule: vCols[5],
                    goodsUnit: vCols[6],
                    counts: vCols[7],
                    price: vCols[8],
                    receAmount: vCols[9],
                    note: vCols[10],
                    compName: null,
                    fileAddUrlList: [],
                    logisticsNumList: [],
                  };
                  if (this.orderTypeAll == null) {
                    if (vCols[1].substr(0, 1) == "G") {
                      this.orderTypeAll == 1;
                      item.buyerOrdersNum = vCols[1];
                      item.isIncludedTax = "托运人货物交接确认";
                    } else if (vCols[1].substr(0, 1) == "S") {
                      this.orderTypeAll == 2;
                      item.sellerOrderNum = vCols[1];
                      item.isIncludedTax = "承运人货物交接确认";
                    } else if (vCols[1].substr(0, 1) == "A") {
                      item.sellerOrderNum = vCols[1];
                      item.isIncludedTax = "实际承运人货物交接确认";
                    }
                  }
                  if (this.orderTypeAll == 1) {
                    item.buyerOrdersNum = vCols[1];
                    item.isIncludedTax = "托运人货物交接确认";
                  }
                  if (this.orderTypeAll == 2) {
                    item.isIncludedTax = "承运人货物交接确认";
                    item.sellerOrderNum = vCols[1];
                  }
                  if (this.orderTypeAll == 3) {
                    item.isIncludedTax = "实际承运人货物交接确认";
                    item.sellerOrderNum = vCols[1];
                  }
                  if (vCols[2]) {
                    item.logisticsNumList[0] = vCols[2];
                  }
                  // if (vCols[4] != "") {
                  //   var reg = new RegExp("/","g");//g,表示全部替换。
                  //   item.addTime =vCols[4].replace( reg, '-');
                  // }
                  if (vCols[9] == null || vCols[9] == "") {
                    if (vCols[7] && vCols[8]) {
                      item.receAmount =
                        Math.round(vCols[7] * vCols[8] * 100) / 100;
                    }
                  }
                  item.compName = this.compMap.get(vCols[1]);
                  tableData.push(item);
                }
              });
            });

            this.tableData = tableData;
          };
          fileReader.readAsBinaryString(files[0]);
          setTimeout(() => {
            this.$Spin.hide();
          }, 1000);
        });
    },
    footerCellClassName({ $rowIndex, column, columnIndex }) {
      return "footer-cell";
    },
    footerMethod({ columns, data }) {
      const sums1 = [];
      const sums2 = [];
      columns.forEach((column, columnIndex) => {
        if (columnIndex === 0) {
          sums1.push("合计");
        } else {
          let sum1Cell = null;
          switch (column.property) {
            case "counts":
              sum1Cell = XEUtils.sum(data, column.property);
              break;
            case "receAmount":
              sum1Cell = XEUtils.sum(data, column.property);
              break;
          }
          sums1.push(sum1Cell);
        }
      });
      // 返回一个二维数组的表尾合计
      return [sums1];
    },
    updateFooterEvent() {
      this.$refs.xTable.updateFooter();
    },
    async queryOrdersBuyerSalesInfoList(row) {
      var self = this;
      let response = await $api.order.post(
        "queryOrdersBuyerSalesInfoList",
        row
      );
      if (response.status == 1) {
        let compList = response.data;
        compList.forEach((vRow, index) => {
          this.compMap.set(vRow.ordersNum, vRow.compName);
        });
        console.log(this.compMap);
      }
    },

    async queryOrdersSellerLv2SalesInfoList(row) {
      var self = this;
      let response = await $api.sellerOrder.post(
        "queryOrdersSellerLv2SalesInfoList",
        row
      );
      if (response.status == 1) {
        let compList = response.data;
        compList.forEach((vRow, index) => {
          this.compMap.set(vRow.ordersNum, vRow.compName);
        });
        console.log(this.compMap);
      }
    },
    async queryOrdersSellerSalesInfoList(row) {
      var self = this;
      let response = await $api.sellerOrder.post(
        "queryOrdersSellerSalesInfoList",
        row
      );
      if (response.status == 1) {
        let compList = response.data;
        compList.forEach((vRow, index) => {
          this.compMap.set(vRow.ordersNum, vRow.compName);
        });
        console.log(this.compMap);
      }
    },
  },
};
</script>

<style>
.modal-container {
  position: relative;
  height: 100%;
}

.modal-footer {
  padding: 10px 0 0 0;
  border-top: 1px solid #eee;
  display: flex;
  justify-content: flex-end;
  width: 100%;
  position: absolute;
  bottom: 0;
}
.demo-spin-icon-load {
  animation: ani-demo-spin 1s linear infinite;
}
.footer-cell {
  border: none;
  background: #e5f2ff;
  background-size: 0 100%, 100% 1px !important;
}
</style>